// extracted by mini-css-extract-plugin
module.exports =  {"SettingsLine":"WelcomeScreenSettingsRow__SettingsLine--6a096","SettingsIconContainer":"WelcomeScreenSettingsRow__SettingsIconContainer--e9392"};